export function getProviderCount(value) {
  let count = (value?.providers || []).length
  return `${count} provider${count === 1 ? '' : 's'}`
}
